import { render } from "./unorganizedList.vue?vue&type=template&id=33818346&scoped=true"
import script from "./unorganizedList.vue?vue&type=script&lang=js"
export * from "./unorganizedList.vue?vue&type=script&lang=js"

import "./unorganizedList.vue?vue&type=style&index=0&id=33818346&lang=scss"
import "./unorganizedList.vue?vue&type=style&index=1&id=33818346&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33818346"]])

export default __exports__